import { useState } from 'react';
import axios from 'axios';
import { API, authAxios } from './adminApi';

export const useProgramActions = (fetchAll) => {
  const [expandedProgram, setExpandedProgram] = useState(null);
  const [programDetails, setProgramDetails] = useState({});
  const [actionLoading, setActionLoading] = useState(false);

  const refreshProgramDetails = async (programId) => {
    const res = await axios.get(`${API}/programs/${programId}`);
    setProgramDetails(prev => ({ ...prev, [programId]: res.data }));
  };

  const toggleProgram = async (programId) => {
    if (expandedProgram === programId) {
      setExpandedProgram(null);
      return;
    }
    setExpandedProgram(programId);
    if (!programDetails[programId]) {
      try {
        await refreshProgramDetails(programId);
      } catch (err) {
        console.error('Failed to load program details', err);
      }
    }
  };

  const verifyProgram = async (programId) => {
    setActionLoading(true);
    try {
      await authAxios.post(`${API}/programs/${programId}/verify`);
      await fetchAll();
      await refreshProgramDetails(programId);
    } catch (err) {
      alert(err.response?.data?.detail || 'Failed to verify program');
    } finally {
      setActionLoading(false);
    }
  };

  const addRule = async (programId, payload) => {
    setActionLoading(true);
    try {
      await authAxios.post(`${API}/programs/${programId}/rules`, payload);
      await refreshProgramDetails(programId);
      return true;
    } catch (err) {
      alert(err.response?.data?.detail || 'Failed to add rule');
      return false;
    } finally {
      setActionLoading(false);
    }
  };

  const addSource = async (programId, payload) => {
    setActionLoading(true);
    try {
      await authAxios.post(`${API}/programs/${programId}/sources`, payload);
      await refreshProgramDetails(programId);
      return true;
    } catch (err) {
      alert(err.response?.data?.detail || 'Failed to add source');
      return false;
    } finally {
      setActionLoading(false);
    }
  };

  const deleteRule = async (ruleId, programId) => {
    if (!window.confirm('Delete this rule?')) return;
    try {
      await authAxios.delete(`${API}/admin/rules/${ruleId}`);
      await refreshProgramDetails(programId);
    } catch {
      alert('Failed to delete rule');
    }
  };

  const seedPrograms = async () => {
    setActionLoading(true);
    try {
      const res = await authAxios.post(`${API}/admin/seed-programs`);
      alert(res.data.message);
      await fetchAll();
    } catch (err) {
      alert(err.response?.data?.detail || 'Failed to seed');
    } finally {
      setActionLoading(false);
    }
  };

  return {
    expandedProgram, programDetails, actionLoading,
    toggleProgram, verifyProgram, addRule, addSource, deleteRule, seedPrograms,
  };
};
